import Api from "~/service/Api";

class TourVideoRequestRepository {
  create(tourId) {
    return Api.post(`/tour/video-requests/${tourId}`, {});
  }
}

export default TourVideoRequestRepository;
